<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="7" :xl="6" :sm="24">
                <a-form-item label="包装规格" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="请选择包装规格" optionFilterProp="children" v-model="queryParam.specification">
                    <a-select-option v-for="(item,index) in specList" :key="index" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="14" :lg="10" :xxl="8" :sm="24">
                <a-form-item label="产品名称/UDI编码/GS1编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入产品名称或者UDI编码或者GS1编码" v-model="queryParam.keywords"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="10" :xl="7" :sm="24">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品标识体系编码名称">
                  <a-select style="width:90%;" showSearch optionFilterProp="children" v-model="queryParam.codeSystem" :allowClear="true">
                    <a-select-option v-for="(item,index) in matype" :key="index" :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>

              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a> -->
                </a-col>
              </span>
              <!-- <template v-if="toggleSearchStatus">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="会员卡号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择会员卡号" showSearch optionFilterProp="children" v-model="queryParam.organId">
                      <a-select-option v-for="(item,index) in retailList" :key="index" :value="item.id">
                        {{ item.supplier }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="仓库名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择仓库" showSearch optionFilterProp="children" v-model="queryParam.depotId">
                      <a-select-option v-for="(depot,index) in depotList" :value="depot.id">
                        {{ depot.depotName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="操作员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择操作员" showSearch optionFilterProp="children" v-model="queryParam.creator">
                      <a-select-option v-for="(item,index) in userList" :key="index" :value="item.id">
                        {{ item.userName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="结算账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择结算账户" showSearch optionFilterProp="children" v-model="queryParam.accountId">
                      <a-select-option v-for="(item,index) in accountList" :key="index" :value="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="单据状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择单据状态" v-model="queryParam.status">
                      <a-select-option value="0">未审核</a-select-option>
                      <a-select-option value="1">已审核</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="单据备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入单据备注" v-model="queryParam.remark"></a-input>
                  </a-form-item>
                </a-col>
              </template> -->
            </a-row>

          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <!-- <a-button @click="myHandleAdd" type="primary">注册产品DI</a-button>
          <a-button @click="myHandleAdd" type="primary">批量导入DI</a-button>
          <a-button @click="myHandleAdd" type="primary">下载模版</a-button>
          <a-button @click="myHandleAdd" type="primary">批量下载DI</a-button>
          <a-button @click="myHandleAdd" type="primary">同步产品</a-button> -->
          <!-- <a-button @click="myHandleDetailPI" type="primary">批量导出</a-button> -->
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="table1" size="middle" bordered :rowKey="(record,index)=>{return index}"
                   :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
                   :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"
                   :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'30px'}"
                   @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="myHandleDetailPI(record)">生成PI</a>
              <a-divider type="vertical" />
              <a @click="myPIrecord(record)">查看PI记录</a>
              <a-divider type="vertical" />
              <a @click="()=>{showExportModal=true;isAllExport=true;row=record}">全部导出</a>
              <!-- <a-divider type="vertical" />
              <a-popconfirm title="确定删除吗?" @confirm="() => myHandleDelete(record)">
                <a>删除</a>
              </a-popconfirm> -->
            </span>
            <template slot="createTime" slot-scope="createTime">
              <span>{{changetime(createTime)}}</span>
            </template>
            <template slot="specCodeSystem" slot-scope="specCodeSystem">
              <span v-if="specCodeSystem === '1'">MA(IDcode)</span>
              <span v-else-if="specCodeSystem === '2'">GS1</span>
              <span v-else-if="specCodeSystem === ''">MA(IDcode)</span>
            </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <!-- <retail-out-modal ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></retail-out-modal> -->
        <PIModel ref="modalDetail" @ok="modalFormOk" @close="modalFormClose"></PIModel>
        <PIreorcd ref="PIreorcdref" @ok="modalFormOk" @close="modalFormClose"></PIreorcd>
        <PIrecordModel ref="PIrecordModelref" @ok="modalFormOk" @close="modalFormClose" @myHandleCopyAdd="(item)=>{showExportModal=true;isAllExport=false;row=item}"></PIrecordModel>
        <bill-excel-iframe ref="billExcelIframe" @ok="modalFormOk" @close="modalFormClose"></bill-excel-iframe>
      </a-card>
    </a-col>

    <a-modal :visible="showExportModal" :footer="null" title="选择导出方式" @cancel="showExportModal = false">
      <div style="display: flex;justify-content: space-evenly;">
        <a-button type="primary" @click="exportFile('txt')">导出Txt</a-button>
        <a-button type="primary" @click="exportFile('excel')">导出Excel</a-button>
      </div>
    </a-modal>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
import PIModel from './modules/PIModel'
import PIreorcd from './modules/PIreorcd'
import PIrecordModel from './modules/PIrecordModel'
// import BillDetail from './dialog/BillDetail'
import BillExcelIframe from '@/components/tools/BillExcelIframe'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { BillListMixin } from './mixins/BillListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'
import { PIadmin } from '@/api/manage'
import { getNowFormatStr } from '@/utils/util'
import { printgetAll } from '@api/api'

export default {
  name: 'RetailOutList',
  mixins: [JeecgListMixin, BillListMixin],
  components: {
    PIModel,
    PIreorcd,
    PIrecordModel,
    // BillDetail,
    BillExcelIframe,
    JEllipsis,
    JDate,
  },
  data() {
    return {
      showExportModal:false,
      isAllExport:false,
      row:{},
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      // 查询条件
      queryParam: {
        page: 1,
        limit: 20,
        keywords: '',
        specification: '',
        codeSystem:''
      },
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      specList: [
        {
          // 包装规格
          label: '初级包装',
          value: '0',
        },
        {
          label: '一级包装',
          value: '1',
        },
        {
          label: '二级包装',
          value: '2',
        },
        {
          label: '三级包装',
          value: '3',
        },
        {
          label: '四级包装',
          value: '4',
        },
        {
          label: '五级包装',
          value: '5',
        },
        {
          label: '六级包装',
          value: '6',
        },
        {
          label: '七级包装',
          value: '7',
        },
        {
          label: '八级包装',
          value: '8',
        },
        {
          label: '九级包装',
          value: '9',
        },
      ],
      matype: [
        {
          label: 'MA码(IDcode)',
          value: '1',
        },
        {
          label: 'GS1',
          value: '2',
        }
      ], // 包装规格
      // 默认列
      columns: [
        { title: '产品UDI-DI编码', dataIndex: 'productDi', width: 150, ellipsis: true },
        { title: '编码类型', dataIndex: 'specCodeSystem', width: 80,scopedSlots: { customRender: 'specCodeSystem' } },
        {
          title: '产品名称',
          dataIndex: 'productName',
          width: 80,
        },
        { title: '规格型号', dataIndex: 'specificationModel', width: 80, ellipsis: true },
        { title: '包装规格', dataIndex: 'specificationName', width: 80 },
        { title: '产品包装级别', dataIndex: 'packageLevelName', width: 80 },
        { title: '生成码数', dataIndex: 'createCodeCount', width: 80 },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 80,
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/productPi/list',
        delete: '/depotHead/delete',
        deleteBatch: '/depotHead/deleteBatch',
        batchSetStatusUrl: '/depotHead/batchSetStatus',
      },
      ul: {
        haha: '/productPi/exportPiExcelByProductId',
        hahaTxt: '/productPi/exportPiTxtByPiId'
      }
    }
  },
  computed: {},
  created() {
    //printgetAll().then(res=>{
      //console.log(res)
      // res.data.forEach(data=>{
      //   data.datas.forEach(datas=>{
      //     let option = JSON.parse(datas.option)
      //     if(!option.options){
      //
      //     }
      //   })
      // })
    //})
    // this.initSystemConfig()
    this.initRetail()
    this.getDepotData()
    this.initUser()
    this.initAccount()
  },
  methods: {
    myPIrecord(record) {
      this.$refs.PIrecordModelref.add(record)
    },

    myHandleCopyAdd(fileName, res,isall) {
      const that = this
      this.$confirm({
        title: "导出",
        content: "请选择导出类型?",
        okText: "导出excel",
        cancelText: "导出txt",
        maskClosable: true,
        okButtonProps: {
          style: { backgroundColor: '#1890ff', borderColor: '#1890ff' }
        },
        cancelButtonProps: {
          style: { backgroundColor: '#1890ff', borderColor: '#1890ff',color:'#fff' }
        },
        onOk: function () {
          that.exportFile(fileName, res,'excel',isall)
        },
        onCancel:function(e,a,b){
          that.exportFile(fileName, res,'txt',isall)
        }
      })
      // this.$confirm('是否删除数据?', '导出', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //   }).then(() => {
      //     handler(...args)
      //   }).catch(() => {});
    },
    exportFile(type){
      let hehe = {
        productId: this.row.id,
        id: this.row.id,
        specificationId: this.row.specificationId
      }
      const fileName = '导出文件'
      let searchObj = {}
      searchObj.search = JSON.stringify(this.queryParam)
      searchObj.currentPage = this.ipagination.current
      searchObj.pageSize = this.ipagination.pageSize

      let url = ''
      if(type=='txt'){
        if(this.isAllExport){
          url = '/productPi/exportPiTxtByProductId'
        }else{
          url = '/productPi/exportPiTxtByPiId'
        }
      }else{
        if(this.isAllExport){
          url = '/productPi/exportPiExcelByProductId'
        }else{
          url = '/productPi/exportPiExcelByPiId'
        }
      }

      PIadmin(url, hehe).then((data) => {
        if (!data) {
          this.$message.warning("文件下载失败")
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          if(type == 'txt'){
            window.navigator.msSaveBlob(new Blob([data], { type: 'text/plain' }), fileName + '.txt')
          }else{
            window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '1.xls')
          }
        } else {
          let url = ''
          if(type == 'txt'){
            url = window.URL.createObjectURL(new Blob([data], { type: 'text/plain' }))
          }else{
            url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          }
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', ( fileName + '_' + getNowFormatStr() + (type == 'txt'?'.txt':'.xls')))
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
      })
    },

    changetime(createTime) {
      return createTime.replace('T', ' ')
    },
    myHandleDetailPI(record) {
      this.$refs.modalDetail.add(record)
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>